import 'reset-css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './css/index.scss';

import './assets/fonts/fonts.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  //<React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  //</React.StrictMode>
);
